import React, { Component } from 'react'
import styled from 'styled-components'
import { Flex } from 'rebass/styled-components'
import PropTypes from 'prop-types'
import Link from 'next/link'
import TagText from 'components/TagText'
import { parse } from 'url'
import ImageCarousel from 'components/ImageCarousel'

import api from '../services/api'
import { API, ACCENT3_COLOR, WHITE_COLOR } from '../services/constants'
import intersection from 'lodash/intersection'

// Image size keys generated by Wordpress
const SIZES = ['full', 'large', 'medium_large', 'medium', 'thumbnail']

const HoverFlex = styled(Flex)``

const StyledHeading = styled.span`
  letter-spacing: ${(props) => props.theme.letterSpacing};
  font-family: ${(props) => props.theme.fonts.sans};
  text-transform: uppercase;
  font-size: ${(props) => props.theme.fontSizes[4]}px;
  white-space: pre;
  display: inline-block;
  ${HoverFlex}:hover & {
    background: linear-gradient(0deg, ${ACCENT3_COLOR} 50%, ${WHITE_COLOR} 51%);
  }
`
const StyledLink = styled.a`
  text-align: left;
  all: unset;
  text-decoration: none;
  color: inherit;

`

// Our parameterized routing is built a bit differently than Wordpress
const buildHref = (link) => {
  return parse(link).path
}

class ContentItem extends Component {
  constructor (props) {
    super(props)
    this.state = {
      images: [],
      loaded: false,
    }
  }

  // Let this component fetch it's own images. Supply a prop of `mediaCategories`
  // which is an array of ids if you want this component to filter out some images
  componentDidMount () {
    const { id, mediaCategories, featuredImageCategory } = this.props
    let coverImageUrl
    let sorted
    // TODO: Fix arbitrary paging here
    api(`${API}/media?parent=${id}&per_page=20`).then((mediaRes) => {
      const filteredMedia = mediaRes.data
        .filter((m) => {
          if (mediaCategories.length) {
            return intersection(m.media_category, mediaCategories).length && m
          }
          return m
        })
        .map((m) => {
          const mediaSizes = Object.keys(m.media_details.sizes)
          // Get first largest size
          let chosenSize = SIZES.map((s) =>
            mediaSizes.includes(s) ? s : null,
          )[0]
          if (m.media_category.includes(featuredImageCategory)) {
            coverImageUrl = m.media_details.sizes[chosenSize].source_url
          }

          return m.media_details.sizes[chosenSize].source_url
        })
      if (coverImageUrl) {
        const coverImageIndex = filteredMedia.indexOf(coverImageUrl)
        sorted = [filteredMedia[coverImageIndex]].concat(
          filteredMedia.slice(0, coverImageIndex),
          filteredMedia.slice(coverImageIndex + 1),
        )
      }

      this.setState({
        images: sorted || filteredMedia,
        loaded: true,
      })
    })
  }

  render () {
    const { title, link, id, slug, acf, mediaCategories = [], excerpt= { rendered: '<p></p>'} } = this.props


    const { images, loaded, underline } = this.state
    const queryParams = {
      slug: slug,
      category: buildHref(link).split('/')[1],
    }

    return (

        <Flex
          flexDirection='column'
          pb={4}
          px={2}
          width={[1, 1, 1 / 2, 1 / 3]}
          style={{ cursor: 'pointer' }}

        >
          <ImageCarousel images={images} />
          <TagText mt={2}>
            {loaded && (
              <span key={`ContentItem-Excerpt-${id}`}>
                {acf.tags_for_excerpt}
              </span>
            )}
          </TagText>
          <HoverFlex
            flexWrap='wrap'
            onMouseEnter={(e) => this.setState({ underline: true })}
            onMouseLeave={(e) => this.setState({ underline: false })}
          ><Link
              passHref
              legacyBehavior
              href={{ pathname: '/post', query: queryParams }}
              as={buildHref(link)}
          ><StyledLink>
            {title.rendered.split(' ').map((t, i) => (
                <StyledHeading
                underline={underline}
                mt={2}
                fontSize={3}
                key={`${t}-${i}`}
              >{`${t} `}</StyledHeading>
            ))}</StyledLink></Link>
          </HoverFlex>
        </Flex>

    )
  }
}

ContentItem.propTypes = {
  // image: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.shape({ rendered: PropTypes.string }),
    PropTypes.string,
  ]),
  acf: PropTypes.shape({
    tags_for_excerpt: PropTypes.string,
  }),
  slug: PropTypes.string,
  link: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  featuredImageCategory: PropTypes.number,
  mediaCategories: PropTypes.arrayOf(PropTypes.number),
}


export default ContentItem
